import React, {useEffect} from 'react';

export const PwaHandler = () => {
    const manifestData = {
            "short_name": 'TONESKY',
            "name": 'TONESKY',
            "icons": [
                {
                    "src": "https://tonesky.ru/images/logo_booking_small.png",
                    "sizes": "160x160",
                    "type": "image/png"
                },
                {
                    "src": "https://tonesky.ru/images/logo_booking.png",
                    "sizes": "204x204",
                    "type": "image/png"
                }
            ],
            "start_url": (window?.location.href || '') + "?utm_source=pwa",
            "display": "standalone",
            "background_color": "#ffffff",
            "description": "Забронировать студию в 3 клика!"
        },
        manifestContent = encodeURIComponent(JSON.stringify(manifestData)),
        manifestUrl = `data:application/manifest+json,${manifestContent}`;

    useEffect(() => {
        const linkTag = document.getElementById('manifest-id');
        if (manifestUrl && linkTag) linkTag.href = manifestUrl;
    }, [manifestUrl]);
    return (
        <div/>
    );
};

export default PwaHandler;